import { buildQueryAndVariablesHash } from "./queryAndVariablesHashing";
export default function shouldGoToNetwork(query, variables, resultStore, memoryCache) {
    const { documentHashWithVariables } = buildQueryAndVariablesHash(query, variables);
    const subQueryStaleness = resultStore.getStalenessState(documentHashWithVariables);
    switch(subQueryStaleness){
        case 'FRESH':
            const isInApolloCache = memoryCache.readQuery({
                query,
                variables
            }) !== null;
            return !isInApolloCache;
        case 'NOT_FOUND':
        case 'STALE':
        default:
            return true;
    }
}

//# sourceMappingURL=shouldGoToNetwork.js.map